import { render, staticRenderFns } from "./UpdateUserModal.vue?vue&type=template&id=bf9f608a&scoped=true&"
import script from "./UpdateUserModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserModal.vue?vue&type=style&index=0&id=bf9f608a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9f608a",
  null
  
)

export default component.exports